package org.hs_soft.runmynesto.pages.home.sub_page.closing_reports.components.reports_table

import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.thenIf
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.model.general.TableColumn
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.closing_reports.ReportsTableHeadersEnum
import org.hs_soft.runmynesto.domain.model.home.closing_reports.closing_report_detail_model.ClosingReportDetailModel
import org.hs_soft.runmynesto.domain.model.home.closing_reports.closing_report_model.ClosingReportItem
import org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card.PeriodDaysEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar.MonthModel
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.animatedWidth
import org.hs_soft.runmynesto.domain.util.extractDate
import org.hs_soft.runmynesto.domain.util.extractTime
import org.hs_soft.runmynesto.domain.util.getCheckoutWidth
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.CustomTable
import org.hs_soft.runmynesto.pages.home.sub_page.closing_reports.components.reports_table.component.ReportsTableFilterOptions
import org.hs_soft.runmynesto.pages.home.sub_page.closing_reports.mvi.ClosingReportsEvent
import org.jetbrains.compose.web.css.px

@Composable
fun ClosingReportsTable(
    modifier: Modifier = Modifier,
    showReportsTableAndDevices:Boolean,
    showFromCalendarFilterDialog:Boolean,
    showToCalendarFilterDialog:Boolean,
    selectedClosingReport: ClosingReportDetailModel?,
    closingReportsList: List<ClosingReportItem>?,
    selectedDateFrom: MonthModel?,
    selectedDateTo: MonthModel?,
    selectedFrom: String,
    selectedTo: String,
    selectedCalendarHeaderYear:Int,
    windowSizeMode: WindowSizeModeEnum,
    selectedPeriodType: PeriodDaysEnum?,
    showDaysFilterDialog: Boolean,
    cashRegisterIds: List<String>,
    event:(ClosingReportsEvent)->Unit,
)
{
    Column(
        modifier = modifier
            .fillMaxWidth()
            .margin(
                top = Dimen.largePadding
            )
            .thenIf(
                windowSizeMode== WindowSizeModeEnum.Desktop,
                Modifier
                    .animatedWidth(
                        widthValue =
                        if (showReportsTableAndDevices)
                        {
                            getCheckoutWidth(windowSizeMode)
                        } else 0.px,
                        duration = Constants.mediumExpandingTime
                    )
            )

    )
    {
        ReportsTableFilterOptions(
            windowSizeMode=windowSizeMode,
            selectedPeriodType = selectedPeriodType,
            showDaysFilterDialog=showDaysFilterDialog,
            selectedDateFrom = selectedDateFrom,
            selectedDateTo = selectedDateTo,
            showToCalendarFilterDialog = showFromCalendarFilterDialog,
            showFromCalendarFilterDialog = showToCalendarFilterDialog,
            selectedTo = selectedTo,
            selectedFrom = selectedFrom,
            selectedCalendarHeaderYear =selectedCalendarHeaderYear,
            setDaysFilterDialogStatus = {
               event(ClosingReportsEvent.SetDaysFilterDialogStatus(it))
            },
            submitFilterItemsBasedOnDays = { from:String, to:String, type:PeriodDaysEnum ->
                event(
                    ClosingReportsEvent.SubmitClosingReportsDaysFilter(
                        from=from,
                        to=to,
                        periodDaysType=type,
                        cashRegisterIds =cashRegisterIds,
                    )
                )
            },
            setFromCalendarFilterDialogStatus = {
                event(ClosingReportsEvent.SetFromCalendarFilterDialogStatus(status = it))
            },
            setToCalendarFilterDialogStatus = {
                event(ClosingReportsEvent.SetToCalendarFilterDialogStatus(status = it))
            },
            onSelectFromDate = {
                event(
                    ClosingReportsEvent.OnSelectFromDate(
                        selectedDate = it,
                        cashRegisterIds = cashRegisterIds
                    )
                )
            },
            onSelectToDate = {
                event(
                    ClosingReportsEvent.OnSelectToDate(
                        selectedDate = it,
                        cashRegisterIds = cashRegisterIds
                    )
                )
            },
            filterDate = {from:String,to:String->
                event(
                    ClosingReportsEvent.SubmitClosingReportsCalendarFilter(
                        from,
                        to,
                        cashRegisterIds
                    )
                )
            },
            closeFromCalendarDialog = {
               event(
                    ClosingReportsEvent.SetFromCalendarFilterDialogStatus(false)
                )
            },
            closeToCalendarDialog = {
                event(
                    ClosingReportsEvent.SetToCalendarFilterDialogStatus(false)
                )
            },
            setNewCalendarHeaderYear = {
                event(
                    ClosingReportsEvent.SetNewCalendarHeaderYear(it)
                )
            }
        )

        CustomEditText(
            modifier = modifier,
            label = "",
            value = "",
            hasLabelSpace = false,
            marginBottom = Dimen.largePadding,
            width =Dimen.checkOutItemWidth,
            fillMaxWidth = windowSizeMode!=WindowSizeModeEnum.Desktop,
            endIconPath = Res.PathIcon.searchBox,
            isRequired = false,
            hint = Strings.current().search,
            onFocusIn = {},
            onFocusOut = {},
            onInputChange = {it, validation ->
                event(ClosingReportsEvent.SearchInClosingReports(it))
            },
        )


        key(closingReportsList) {

            val (columns, tableData) = setClosingReportTableInfo(
                closingReportsList=closingReportsList
            )

            CustomTable(
                columns = columns,
                data = tableData,
                height=Dimen.closingReportsTableHeight,
                showRefreshButton = true,
                selectedId = selectedClosingReport?.data?.cashAssist?.getClosing?.id,
                inactiveItem = { row ->
                    row[ApiUtils.Field.inactive]?.toString()?.toBoolean() == true
                },
                onRowClick = {id,_->
                    event(ClosingReportsEvent.OnClosingReportClick(id=id))
                },
            )
        }

    }


}

private fun setClosingReportTableInfo(
    closingReportsList: List<ClosingReportItem>?
): Pair<List<TableColumn>, List<Map<String, Any?>>?>
{
    val columns = listOf(
        TableColumn(
            header = ReportsTableHeadersEnum.DATE.title,
            key = "date",
            isNumeric = ReportsTableHeadersEnum.DATE.arrangement == Arrangement.End,
            sortFunction = { row ->
                val dateStr = row["date"]?.toString() ?: ""
                try {
                    val parts = dateStr.split(".")
//                            String.format("%04d%02d%02d", parts[2].toInt(),
//                                parts[1].toInt(), parts[0].toInt())
                    ""
                } catch (e: Exception) {
                    dateStr
                }
            }
        ),
        TableColumn(
            header = ReportsTableHeadersEnum.TIME.title,
            key = "time",
            isNumeric = ReportsTableHeadersEnum.TIME.arrangement == Arrangement.End,
            sortFunction = { row ->
                (row["time"]?.toString() ?: "").replace(":", "")
            }
        ),
        TableColumn(
            header = ReportsTableHeadersEnum.NUMBER_DOT.title,
            key = "number",
            isNumeric = ReportsTableHeadersEnum.NUMBER_DOT.arrangement == Arrangement.End
        ),
        TableColumn(
            header = ReportsTableHeadersEnum.DEVICES.title,
            key = "register",
            isNumeric = ReportsTableHeadersEnum.DEVICES.arrangement == Arrangement.End
        ),
        TableColumn(
            header = ReportsTableHeadersEnum.SALES_VOLUME.title,
            key = "amount",
            isNumeric = ReportsTableHeadersEnum.SALES_VOLUME.arrangement == Arrangement.End,
            sortFunction = { row ->
                (row["amount"]?.toString() ?: "0").replace(",", "")
                    .toDoubleOrNull() ?: 0.0
            }
        )
    )

    val tableData = closingReportsList?.map { report ->
        mapOf(
            "id" to report.id,
            "date" to extractDate(report.dateTime ?: ""),
            "time" to extractTime(report.dateTime ?: ""),
            "number" to report.number,
            "register" to report.cashRegister,
            "amount" to report.total
        )
    }
    return Pair(columns, tableData)
}






